<template>
  <div>
    <div class="flex pt-8">
      <div
        class="text-secondary-500 text-sm px-2 py-1 border border-secondary-500 rounded"
        :class="{ availableTag: video.available }"
      >
        Disponible<span v-if="!video.available">
          el {{ video.date }} a las {{ video.time }}</span
        >
      </div>
    </div>
    <div v-if="!video.available" class="flex mt-4 ml-1">
      <!-- <AddToOutlookCalendar class="ml-6" :video="video" service="live">
              Outlook
            </AddToOutlookCalendar>
            <AddToOutlookCalendar class="ml-6" :video="video" service="office">
              Office 365
            </AddToOutlookCalendar> -->
      <AddToIcsCalendar :video="video" />
      <AddToGoogleCalendar class="ml-6" :video="video" />
    </div>
  </div>
</template>

<script>
import videoListItemContentMixin from '@/mixins/videoListItemContentMixin'
import AddToGoogleCalendar from '@/components/AddToGoogleCalendar'
// import AddToOutlookCalendar from '@/components/AddToOutlookCalendar'
import AddToIcsCalendar from '@/components/AddToIcsCalendar'

export default {
  components: {
    AddToGoogleCalendar,
    AddToIcsCalendar,
  },

  mixins: [videoListItemContentMixin],
}
</script>

<style scoped>
.availableTag {
  @apply text-white bg-green-500 border-green-500;
}
</style>
